import { ref } from 'vue'
import { getAcceptedFileFormats, validateArchiveFile } from '@/services/fileService.js';
import { useToast } from '@/composables/use-toast';

const { addToast } = useToast();

export const referenceFileNames = ref([]);

/**
 * Validate the content of an archive file
 * @param {string} filePath - The path to the archive file
 * @returns {Promise<Object>} - The response from the API
 * @throws {Error} - If the validation fails
 */
export const validateReferenceFileContent = async (filePath) => {
    try {
        const response = await validateArchiveFile(filePath);
        if(response.error){
            throw new Error(response.message);
        }
        return response
    } catch (error) {
        console.error('Error extracting file names:', error);
        addToast(`Error reading archive: ${error.message}`, 'error');
        return { data: { valid: false, error: error.message } };
    }
};

/**
 * Get the accepted file formats
 * @returns {Promise<Array>} - The accepted file formats
 */
export const getAcceptFormats = async () => {
    const response = await getAcceptedFileFormats()
    return response.data ? response.data.map((format) => format.extension) : []
}